import { api } from '../api';
import { AxiosResponse } from "axios";
import { StandardResponse } from '../interfaces/Common';
import { ExamListByCode, ExamHistory, InitiateExam, ExamAttemptDetails, SubmitExam, ExamResultsResponse, ExamHistoryWithAttempts } from '../interfaces/Exam';

const DEFAULT_PAGE_LIMIT = 10;

export async function getExamListsByCode(code: string): Promise<StandardResponse<ExamListByCode[]>> {
    const response: AxiosResponse<StandardResponse<ExamListByCode[]>> = await api.get(`/preboard/me/codes/${code}/exams`);
    return response.data;
}

export async function getExamHistory(params: { limit?: number }): Promise<StandardResponse<ExamHistory[]>> {
    const response: AxiosResponse<StandardResponse<ExamHistory[]>> = await api.get('/preboard/me/history', {
        params: {
            limit: params?.limit || DEFAULT_PAGE_LIMIT,
        }
    });
    return response.data;
}

export async function initiateExam(examId: string): Promise<StandardResponse<InitiateExam>> {
    const response: AxiosResponse<StandardResponse<InitiateExam>> = await api.get(`/preboard/me/exams/${examId}`);
    return response.data;
}

export async function getExamAttemptDetailsById(attemptId: string): Promise<StandardResponse<ExamAttemptDetails>> {
    const response: AxiosResponse<StandardResponse<ExamAttemptDetails>> = await api.get(`/preboard/me/attempts/${attemptId}`);
    return response.data;
}

export async function submitExam(examId: string, exam: { examAttemptId: string; answers: string[] }): Promise<StandardResponse<SubmitExam>> {
    const response: AxiosResponse<StandardResponse<SubmitExam>> = await api.post(`/preboard/me/exams/${examId}/submit`, exam);
    return response.data;
}

export async function getExamResultsByCodeId(code: string): Promise<StandardResponse<ExamResultsResponse>> {
    const response: AxiosResponse<StandardResponse<ExamResultsResponse>> = await api.get(`/preboard/me/codes/${code}/results`);
    return response.data;
}

export async function getExamHistoryById(examId: string): Promise<StandardResponse<ExamHistoryWithAttempts>> {
    const response: AxiosResponse<StandardResponse<ExamHistoryWithAttempts>> = await api.get(`/preboard/me/exams/${examId}/results`);
    return response.data;
}